import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const MODAL_DEFAULT_BUTTON_CANCEL = {
    label: 'Cancelar',
    size: 's',
    startIcon: faTimesCircle,
    variant: 'ghost'
};
export const MODAL_DEFAULT_BUTTON_SUCCESS = {
    label: 'Guardar',
    size: 's',
    startIcon: faCheckCircle
};
export const MODAL_DEFAULT_CLOSEABLE = true;
export const MODAL_DEFAULT_BUTTONS_FULL_WIDTH = false;
export const MODAL_DEFAULT_DISABLE_ESC_KEY = false;
export const MODAL_DEFAULT_DISABLE_OUTSIDE_CLICK = false;
export const MODAL_DEFAULT_IS_OPEN = false;
export const MODAL_DEFAULT_SIZE = 'm';
export const MODAL_PORTAL_DIV_ID = 'ui-library-portal-id';
export const MODAL_PORTAL_DIV_CLASSNAME = 'ui-library-portal-classname';
// Labels
export const MODAL_ACTION_BUTTON_CANCEL_ARIA_LABEL = 'action-cancel';
export const MODAL_ACTION_BUTTON_SUCCESS_ARIA_LABEL = 'action-success';
export const MODAL_TOP_BUTTON_ARIA_LABEL = 'cross-close';
// Styled-components.
export const MODAL_SIZES_MAP = {
    '2xl': 1200,
    xl: 960,
    l: 736,
    m: 680,
    s: 480
};
//# sourceMappingURL=Modal.constants.js.map